import { cn } from '@shared/components/shadcn';
import { BackChevron } from '../BackChevron/BackChevron';

type PageHeaderProps = {
  title?: string;
  className?: string;
  variant?: 'header' | 'subheader';
  href?: string;
  fallbackUrl?: string;
};

function PageHeader({ title = '', className, variant = 'header', href, fallbackUrl }: PageHeaderProps) {
  const commonAttrs = {
    'data-track-name': 'Back',
    'data-testid': 'back-button',
  };

  return (
    <div data-slot="page-header" className={cn('flex items-center gap-4 z-10', className)}>
      <BackChevron overrideHref={href} fallbackUrl={fallbackUrl} {...commonAttrs} headerVariant={variant} {...(variant === 'subheader' && { variant: 'ghost' })} />
      {variant === 'header' ? <h1 className="heading-4">{title}</h1> : <h5>{title}</h5>}
    </div>
  );
}

export { PageHeader };
